
import { Descriptions, Badge, Button, Typography, Space } from "antd";
import StatementView from "./StatementView";

const { Text } = Typography;

export default function NewStatementView({ status, initiateGeneration, statement }) {
  return (
    <>
      { status.status && <StatementView statement={status.statement} /> }
      { status.patching && <Text> <Badge status="processing" /> Generating... </Text> }
      {
        status?.errorMsg
          && <Descriptions.Item label="Error Message">
            <Space>
            <Text type="error"><Badge status="error" /> {status?.errorMsg}</Text>
            <Button htmlType="button" size="small" onClick={() => initiateGeneration([statement], status.shouldPersist)}>Retry</Button>
          </Space>
        </Descriptions.Item>
      }
    </>
  );
}